<template>
     <div class="form__item">
        <div v-if="!hideLabel" class="form__label">{{ label }}</div>
        <datepicker class="form__input md" @selected="handleSelectedDate" :value="value" :placeholder="placeholder || ' '" :disabled-dates="disabledDates"/>
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";

export default {
    name: 'DatePicker',
    props: {
       label: String, 
       onDateSelected: Function,
       hideLabel: Boolean , 
       value: String,
       placeholder: String,
       disabledDates: Object
    },
    components: {
        Datepicker
    },
    setup(props) {
        const handleSelectedDate = date => props.onDateSelected(date)
        return {
            handleSelectedDate
        }
    }
}
</script>
<style lang="scss">
 .form__item {
     display: flex;
     flex-direction: column;
     justify-content: flex-end !important;

    .form__input {
         width: 100% !important;
         max-height: 35px;
    }

    .md {
        input {
             max-width: 90px;
        }
    }
 }
</style>
